import "../scss/page.scss";

import "../scss/ourwork.scss";

import "./scripts/dm-marketing/navbar.js";
import "./scripts/our-work/work-items.js";
import "./scripts/slick/our-work.js";
import "./scripts/matchHeight/our-work.js";
import "./scripts/animatenumber.js";
import "./scripts/calculatepadding.js";
